export const availableHotspots =  [
    "HSR001",
    "HSL001",
    "HTR001",
    "HTL001",
    "HBR001",
    "HBL001",
    "HCT001"
]
